import { render, staticRenderFns } from "./SetHandle.vue?vue&type=template&id=c60aa896&scoped=true"
import script from "./SetHandle.vue?vue&type=script&lang=js"
export * from "./SetHandle.vue?vue&type=script&lang=js"
import style0 from "./SetHandle.vue?vue&type=style&index=0&id=c60aa896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60aa896",
  null
  
)

export default component.exports